import {
  BooleanSelection,
  Core,
  DaySelection,
  DynamicNumberDescriptionAmountInput,
  AmountToggleInput,
  DynamicText,
  Element,
  NumberInput,
  DynamicOptionsWithNumberAndSelection,
  DynamicOptionsWithNumberAndSelectionOption,
  OrganizationUnitCooperationSelection,
  OrganizationUnitNumberInput,
  OrganizationUnitSelection,
  PrebuildArbeitstagSubType,
  PrebuildEinzelarbeitSubType,
  PrebuildMeetingGroesseBesprechungSubType,
  PrebuildMeetingGroesseCoworkingSubType,
  PrebuildType,
  Selection,
  SelectionOption,
  Slider,
  SliderDropdown,
  SliderDropdownGroup,
  SliderDropdownOption,
  SliderGroup,
  StaticText,
  Type,
} from '../../../../../types/Survey/Element'
import { getUUID } from '../../../../../utility'

type PrebuildPayload = {
  prebuildType?:
    | PrebuildType
    | PrebuildArbeitstagSubType
    | PrebuildEinzelarbeitSubType
    | PrebuildMeetingGroesseBesprechungSubType
    | PrebuildMeetingGroesseCoworkingSubType
  title?: string
  helpText?: string
  description?: string
  leftLabel?: string
  leftValue?: number
  rightLabel?: string
  rightValue?: number
  percentageLabel?: boolean
  enableCounterWeight?: boolean
  counterWeightText?: string
  dropdownOptions?: SliderDropdownOption[]
  yesLabel?: string
  noLabel?: string
}

const getTemplateElement = (type: Type, prebuildPayload: PrebuildPayload = {}): Element | false => {
  const core = {
    uuid: getUUID(),
    type,
  }
  if (type === Type.STATIC_TEXT) {
    const element: StaticText = {
      ...(core as Core<Type.STATIC_TEXT>),
      title: '',
      description: '',
      ...prebuildPayload,
    }
    return element
  } else if (type === Type.SLIDER_GROUP) {
    const element: SliderGroup = {
      ...(core as Core<Type.SLIDER_GROUP>),
      sliders: [getTemplateElement(Type.SLIDER) as Slider, getTemplateElement(Type.SLIDER) as Slider],
      ...prebuildPayload,
    }
    return element
  } else if (type === Type.SLIDER) {
    const element: Slider = {
      ...(core as Core<Type.SLIDER>),
      title: '',
      description: '',
      helpText: '',
      enableCounterWeight: false,
      counterWeightText: '',
      leftLabel: '0',
      leftValue: 0,
      rightLabel: '100',
      rightValue: 100,
      percentageLabel: true,
      ...prebuildPayload,
    }
    return element
  } else if (type === Type.SELECTION) {
    const element: Selection = {
      ...(core as Core<Type.SELECTION>),
      title: '',
      description: '',
      helpText: '',
      isMultipleChoice: false,
      maxMultipleChoice: 3,
      forceMultipleChoiceMax: false,
      options: [getSelectionOptionTemplate()],
      ...prebuildPayload,
    }
    return element
  } else if (type === Type.DYNAMIC_TEXT) {
    const element: DynamicText = {
      ...(core as Core<Type.DYNAMIC_TEXT>),
      title: '',
      description: '',
      helpText: '',
      maxAnswerCount: 5,
      ...prebuildPayload,
    }
    return element
  } else if (type === Type.DAY_SELECTION) {
    const element: DaySelection = {
      ...(core as Core<Type.DAY_SELECTION>),
      ...prebuildPayload,
    }
    return element
  } else if (type === Type.ORGANIZATION_UNIT_SELECTION) {
    const element: OrganizationUnitSelection = {
      ...(core as Core<Type.ORGANIZATION_UNIT_SELECTION>),
      ...prebuildPayload,
    }
    return element
  } else if (type === Type.ORGANIZATION_UNIT_COOPERATION_SELECTION) {
    const element: OrganizationUnitCooperationSelection = {
      ...(core as Core<Type.ORGANIZATION_UNIT_COOPERATION_SELECTION>),
      maxMultipleChoice: 3,
      ...prebuildPayload,
    }
    return element
  } else if (type === Type.SLIDER_DROPDOWN) {
    const element: SliderDropdown = {
      ...(core as Core<Type.SLIDER_DROPDOWN>),
      title: '',
      description: '',
      helpText: '',
      enableCounterWeight: false,
      counterWeightText: '',
      leftLabel: '0',
      leftValue: 0,
      rightLabel: '100',
      rightValue: 100,
      percentageLabel: true,
      dropdownOptions: [
        {
          uuid: getUUID(),
          value: '',
        },
        {
          uuid: getUUID(),
          value: '',
        },
      ],
      ...prebuildPayload,
    }
    return element
  } else if (type === Type.SLIDER_DROPDOWN_GROUP) {
    const element: SliderDropdownGroup = {
      ...(core as Core<Type.SLIDER_DROPDOWN_GROUP>),
      sliderDropdowns: [getTemplateElement(Type.SLIDER_DROPDOWN) as SliderDropdown, getTemplateElement(Type.SLIDER_DROPDOWN) as SliderDropdown],
      ...prebuildPayload,
    }
    return element
  } else if (type === Type.BOOLEAN_SELECTION) {
    const element: BooleanSelection = {
      ...(core as Core<Type.BOOLEAN_SELECTION>),
      yesLabel: 'Ja',
      noLabel: 'Nein',
      ...prebuildPayload,
    }
    return element
  } else if (type === Type.NUMBER_INPUT) {
    const element: NumberInput = {
      ...(core as Core<Type.NUMBER_INPUT>),
      suffix: ' m²',
      ...prebuildPayload,
    }
    return element
  } else if (type === Type.DYNAMIC_NUMBER_DESCRIPTION_AMOUNT_INPUT) {
    const element: DynamicNumberDescriptionAmountInput = {
      ...(core as Core<Type.DYNAMIC_NUMBER_DESCRIPTION_AMOUNT_INPUT>),

      ...prebuildPayload,
    }
    return element
  } else if (type === Type.AMOUNT_TOGGLE_INPUT) {
    const element: AmountToggleInput = {
      ...(core as Core<Type.AMOUNT_TOGGLE_INPUT>),
      amountSuffix: ' Stück',
      ...prebuildPayload,
    }
    return element
  } else if (type === Type.ORGANIZATION_UNIT_NUMBER_INPUT) {
    const element: OrganizationUnitNumberInput = {
      ...(core as Core<Type.ORGANIZATION_UNIT_NUMBER_INPUT>),
      ...prebuildPayload,
    }
    return element
  } else if (type === Type.DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION_OPTION) {
    const element: DynamicOptionsWithNumberAndSelectionOption = {
      ...(core as Core<Type.DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION_OPTION>),
      name: '',
      ...prebuildPayload,
    }
    return element
  } else if (type === Type.DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION) {
    const element: DynamicOptionsWithNumberAndSelection = {
      ...(core as Core<Type.DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION>),
      numberSuffix: ' m²',
      normLabel: '',
      dynamicOptionsWithNumberAndSelection: [
        getTemplateElement(Type.DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION_OPTION) as DynamicOptionsWithNumberAndSelectionOption,
        getTemplateElement(Type.DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION_OPTION) as DynamicOptionsWithNumberAndSelectionOption,
      ],
      ...prebuildPayload,
    }
    return element
  }
  return false
}

export const getSelectionOptionTemplate = (): SelectionOption => {
  return {
    uuid: getUUID(),
    value: '',
  }
}

export const getPrebuildTemplateElement = (prebuildType: PrebuildType): Element | false => {
  // ARBEITSTAG
  if (PrebuildType.ARBEITSTAG === prebuildType) {
    const sliderGroup = getTemplateElement(Type.SLIDER_GROUP, {
      prebuildType: PrebuildType.ARBEITSTAG,
      title: 'Wie sah Ihr Arbeitstag heute aus?',
      description:
        'Unterteilen Sie Ihren Arbeitstag in die erläuterten sechs Tätigkeitsfelder. Unterteilen Sie Ihren Arbeitstag in die erläuterten sechs Tätigkeitsfelder.',
    }) as SliderGroup
    sliderGroup.sliders = [
      getTemplateElement(Type.SLIDER, {
        prebuildType: PrebuildArbeitstagSubType.EINZELARBEIT,
        title: 'Einzelarbeit',
        description: 'kurze Telefonate, kurze Gespräche eingeschlossen',
        helpText: '',
        leftLabel: '0',
        leftValue: 0,
        rightLabel: '100',
        rightValue: 100,
        percentageLabel: true,
      }) as Slider,
      getTemplateElement(Type.SLIDER, {
        prebuildType: PrebuildArbeitstagSubType.KOMMUNIKATION,
        title: 'Kommunikation',
        description: '',
        helpText: '',
        leftLabel: '0',
        leftValue: 0,
        rightLabel: '100',
        rightValue: 100,
        percentageLabel: true,
      }) as Slider,
      getTemplateElement(Type.SLIDER, {
        prebuildType: PrebuildArbeitstagSubType.KOLLABORATION,
        title: 'Kollaboration',
        description: '',
        helpText: '',
        leftLabel: '0',
        leftValue: 0,
        rightLabel: '100',
        rightValue: 100,
        percentageLabel: true,
      }) as Slider,
    ]
    return sliderGroup
    // EINZELARBEIT
  } else if (PrebuildType.EINZELARBEIT === prebuildType) {
    const sliderGroup = getTemplateElement(Type.SLIDER_GROUP, {
      prebuildType: PrebuildType.EINZELARBEIT,
      title: 'Wie setzt sich die Einzelarbeit zusammen?',
    }) as SliderGroup
    sliderGroup.sliders = [
      getTemplateElement(Type.SLIDER, {
        prebuildType: PrebuildEinzelarbeitSubType.KLASSISCHE_ARBEIT,
        title: 'Klassische Arbeit',
        description: 'mittlere Konzentration, kurze Telefonate, kurze Gespräche',
        helpText: '',
        leftLabel: '0',
        leftValue: 0,
        rightLabel: '100',
        rightValue: 100,
        percentageLabel: true,
      }) as Slider,
      getTemplateElement(Type.SLIDER, {
        prebuildType: PrebuildEinzelarbeitSubType.FOKUSSIERTE_ARBEIT_MORE_THEN_HOUR,
        title: 'Fokussierte Arbeit',
        description: 'hohe Konzentration, > 60 min',
        helpText: '',
        leftLabel: '0',
        leftValue: 0,
        rightLabel: '100',
        rightValue: 100,
        percentageLabel: true,
      }) as Slider,
      getTemplateElement(Type.SLIDER, {
        prebuildType: PrebuildEinzelarbeitSubType.FOKUSSIERTE_ARBEIT_LESS_THEN_HOUR,
        title: 'Fokussierte Arbeit',
        description: 'hohe Konzentration, < 60 min',
        helpText: '',
        leftLabel: '0',
        leftValue: 0,
        rightLabel: '100',
        rightValue: 100,
        percentageLabel: true,
      }) as Slider,
    ]
    return sliderGroup
    // MEETING_GROESSE_COWORKING
  } else if (PrebuildType.MEETING_GROESSE_BESPRECHUNG === prebuildType) {
    const sliderGroup = getTemplateElement(Type.SLIDER_DROPDOWN_GROUP, {
      prebuildType: PrebuildType.MEETING_GROESSE_BESPRECHUNG,
      title: 'In welchen Gruppengrößen finden Ihre Besprechungen und Video-Calls (> 30min) statt und wie planen Sie diese?',
    }) as SliderDropdownGroup
    sliderGroup.sliderDropdowns = [
      getTemplateElement(Type.SLIDER_DROPDOWN, {
        prebuildType: PrebuildMeetingGroesseBesprechungSubType.PERSON_2,
        title: '2 Personen',
        dropdownOptions: [
          {
            uuid: 'geplant',
            value: 'Geplant',
          },
          {
            uuid: 'spontan',
            value: 'Spontan',
          },
          {
            uuid: 'ausgeglichen',
            value: 'Ausgeglichen',
          },
        ],
      }) as SliderDropdown,
      getTemplateElement(Type.SLIDER_DROPDOWN, {
        prebuildType: PrebuildMeetingGroesseBesprechungSubType.PERSON_3_4,
        title: '3 - 4 Personen',
        dropdownOptions: [
          {
            uuid: 'geplant',
            value: 'Geplant',
          },
          {
            uuid: 'spontan',
            value: 'Spontan',
          },
          {
            uuid: 'ausgeglichen',
            value: 'Ausgeglichen',
          },
        ],
      }) as SliderDropdown,
      getTemplateElement(Type.SLIDER_DROPDOWN, {
        prebuildType: PrebuildMeetingGroesseBesprechungSubType.PERSON_5_8,
        title: '5 - 8 Personen',
        dropdownOptions: [
          {
            uuid: 'geplant',
            value: 'Geplant',
          },
          {
            uuid: 'spontan',
            value: 'Spontan',
          },
          {
            uuid: 'ausgeglichen',
            value: 'Ausgeglichen',
          },
        ],
      }) as SliderDropdown,
      getTemplateElement(Type.SLIDER_DROPDOWN, {
        prebuildType: PrebuildMeetingGroesseBesprechungSubType.PERSON_9_12,
        title: '9 - 12 Personen',
        dropdownOptions: [
          {
            uuid: 'geplant',
            value: 'Geplant',
          },
          {
            uuid: 'spontan',
            value: 'Spontan',
          },
          {
            uuid: 'ausgeglichen',
            value: 'Ausgeglichen',
          },
        ],
      }) as SliderDropdown,
      getTemplateElement(Type.SLIDER_DROPDOWN, {
        prebuildType: PrebuildMeetingGroesseBesprechungSubType.PERSON_13_16,
        title: '13 - 16 Personen',
        dropdownOptions: [
          {
            uuid: 'geplant',
            value: 'Geplant',
          },
          {
            uuid: 'spontan',
            value: 'Spontan',
          },
          {
            uuid: 'ausgeglichen',
            value: 'Ausgeglichen',
          },
        ],
      }) as SliderDropdown,
    ]
    return sliderGroup
    // MEETING_GROESSE_COWORKING
  } else if (PrebuildType.MEETING_GROESSE_COWORKING === prebuildType) {
    const sliderGroup = getTemplateElement(Type.SLIDER_DROPDOWN_GROUP, {
      prebuildType: PrebuildType.MEETING_GROESSE_COWORKING,
      title: 'In welchen Gruppengrößen finden Ihre Projektarbeiten, Workshops oder Gruppenarbeiten statt und wie planen Sie diese?',
    }) as SliderDropdownGroup
    sliderGroup.sliderDropdowns = [
      getTemplateElement(Type.SLIDER_DROPDOWN, {
        prebuildType: PrebuildMeetingGroesseCoworkingSubType.PERSON_2_4,
        title: '2 - 4 Personen',
        dropdownOptions: [
          {
            uuid: 'geplant',
            value: 'Geplant',
          },
          {
            uuid: 'spontan',
            value: 'Spontan',
          },
          {
            uuid: 'ausgeglichen',
            value: 'Ausgeglichen',
          },
        ],
      }) as SliderDropdown,
      getTemplateElement(Type.SLIDER_DROPDOWN, {
        prebuildType: PrebuildMeetingGroesseCoworkingSubType.PERSON_5_8,
        title: '5 - 8 Personen',
        dropdownOptions: [
          {
            uuid: 'geplant',
            value: 'Geplant',
          },
          {
            uuid: 'spontan',
            value: 'Spontan',
          },
          {
            uuid: 'ausgeglichen',
            value: 'Ausgeglichen',
          },
        ],
      }) as SliderDropdown,
      getTemplateElement(Type.SLIDER_DROPDOWN, {
        prebuildType: PrebuildMeetingGroesseCoworkingSubType.PERSON_9_12,
        title: '9 - 12 Personen',
        dropdownOptions: [
          {
            uuid: 'geplant',
            value: 'Geplant',
          },
          {
            uuid: 'spontan',
            value: 'Spontan',
          },
          {
            uuid: 'ausgeglichen',
            value: 'Ausgeglichen',
          },
        ],
      }) as SliderDropdown,
      getTemplateElement(Type.SLIDER_DROPDOWN, {
        prebuildType: PrebuildMeetingGroesseCoworkingSubType.PERSON_13_16,
        title: '13 - 16 Personen',
        dropdownOptions: [
          {
            uuid: 'geplant',
            value: 'Geplant',
          },
          {
            uuid: 'spontan',
            value: 'Spontan',
          },
          {
            uuid: 'ausgeglichen',
            value: 'Ausgeglichen',
          },
        ],
      }) as SliderDropdown,
    ]
    return sliderGroup
    // TELEPHONE_MORE_THEN
  } else if (PrebuildType.TELEPHONE_MORE_THEN === prebuildType) {
    const telephoneMoreThen = getTemplateElement(Type.BOOLEAN_SELECTION, {
      prebuildType: PrebuildType.TELEPHONE_MORE_THEN,
      title: 'Telefonierst Du mehr als 60 % des Tages?',
      yesLabel: 'Ja',
      noLabel: 'Nein',
    }) as BooleanSelection
    return telephoneMoreThen
  }
  return false
}

export default getTemplateElement
